import PropTypes from 'prop-types';

import { Information } from 'src/components/Information';
import { PerformanceRowsLimitTooltip } from 'src/components/PerformanceRowsLimitTooltip';
import { flatConnectedAccounts } from 'src/data/performance';
import { formatNumber } from 'src/lib/format';

import { useStyles } from './useStyles';

export const RowsUsageHeader = ({ limitData, connectedAccounts }) => {
  const styles = useStyles();
  const { currentCount, limit } = limitData;
  const isFeatureLimited = currentCount >= limit;
  const flattenConnectedAccounts = flatConnectedAccounts(connectedAccounts, true);

  return (
    <div className={styles.rowsLimitContainer}>
      <span data-testid="FeatureLimitedProgressBar_limitCountLabel">
        <span className={styles.semiBoldLabel}>
          <span>{isFeatureLimited ? formatNumber(limit) : formatNumber(currentCount)}</span>/
          <span>{formatNumber(limit)}</span>
        </span>{' '}
        performance data rows used
      </span>
      <Information
        className={styles.informationIcon}
        content={<PerformanceRowsLimitTooltip connectedAccounts={flattenConnectedAccounts} />}
      />
    </div>
  );
};

RowsUsageHeader.propTypes = {
  limitData: PropTypes.shape({
    currentCount: PropTypes.number,
    limit: PropTypes.number,
  }).isRequired,
  connectedAccounts: PropTypes.shape({}),
};
RowsUsageHeader.defaultProps = {
  connectedAccounts: {},
};
